import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../config'

export async function getAllUsersLeads(query) {
    try {
        const response = await axios(`${REACT_APP_API_ABM_FW}/users/leads?${query}`)
        return response?.data?.data || []
    } catch (e) {
        console.error('Error al obtener usuarios para leads', e)
        return []
    }
}
